export default __webpack_public_path__ + "static/Bola-ef929ee17f05587d861a5a3eea589b6c.png";